mutation TOP_UP (
  $durationMinutes: Int!,
  $reservationId: UUID!
  $payViaCredits: Boolean,
) {
  topup(
    durationMinutes: $durationMinutes,
    reservationId: $reservationId,
    payViaCredits: $payViaCredits
  ) {
    error
    success
    clientSecret
    customerSessionClientSecret
    returnUrl
    amount
    orderId
  }
}
